import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { UserAutocompleteComponent } from '../user-autocomplete/user-autocomplete.component';
import { BusinessUnitInputComponent } from '../businessunit-input/businessunit-input.component';

import { MatCheckbox } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'unite-customer-settings',
    templateUrl: './customer-settings.component.html',
    styleUrls: ['./customer-settings.component.scss'],
    imports: [MatIcon, TranslateModule, MatCheckbox, ReactiveFormsModule, BusinessUnitInputComponent, UserAutocompleteComponent]
})
export class CustomerSettingsComponent {

  isCreating = input(false);
  userControl = input<FormControl>();
  existingControl = input<FormControl>();
  businessunitControl = input<FormControl>();

}
